<template>
    <div class="my-3 col-12">
        <draggable
            v-if="subMenus.length"
            :list="subMenus"
            handle=".handle"
            @start="drag = true"
            @end="drag = false"
        >
            <div
                v-for="(subMenu, subMenuIndex) in subMenus"
                :key="subMenuIndex"
                class="card mb-3"
                :class="{
                    'error-border': v.$each[subMenuIndex].$error
                }"
            >
                <button
                    class="btn col-12 p-2 bg-light text-center align-items-center d-flex"
                    @click="editSubMenu(subMenuIndex)"
                >
                    <button class="handle btn btn-info">
                        <i class="fas fa-arrows-alt" />
                    </button>
                    <button
                        class="btn btn-danger waves-effect waves-ligh mx-3"
                        type="button"
                        @click.stop="deleteItem(subMenuIndex)"
                    >
                        <i class="far fa-trash-alt" />
                    </button>
                    #{{ subMenuIndex + 1 }} | {{ subMenu.title }}
                </button>
                <div v-if="editedIndex === subMenuIndex" class="pt-3">
                    <div class="form-group col-12">
                        <label :for="`submenuTitle_${index}_${subMenuIndex}`">
                            Title
                        </label>
                        <input
                            :id="`submenuTitle_${index}_${subMenuIndex}`"
                            v-model="subMenu.title"
                            class="form-control"
                            :class="{
                                'is-invalid': v.$each[subMenuIndex].title.$error
                            }"
                            dir="auto"
                            @input="emitSubmenus"
                        />
                    </div>
                    <links
                        :value="subMenu.items"
                        :v="v.$each[subMenuIndex].items"
                        @input="onLinksChange($event, subMenuIndex)"
                    />
                </div>
            </div>
        </draggable>

        <div v-else class="d-flex justify-content-center my-3">
            No menu items added yet!
        </div>

        <div class="d-flex justify-content-center">
            <button
                class="btn btn-success waves-effect waves-light my-2"
                @click="addItem"
            >
                <i class="fas fa-plus-circle" /> Add menu item
            </button>
        </div>
    </div>
</template>


<script>
import Draggable from 'vuedraggable';
import Links from './Links';

export default {
    components: {
        Draggable,
        Links
    },

    props: {
        value: {
            type: Array,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        v: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            subMenus: [...this.value],
            editedIndex: null
        };
    },

    methods: {
        deleteItem(index) {
            this.subMenus.splice(index, 1);
        },

        addItem() {
            this.subMenus.push({ title: '', items: [] });

            this.emitSubmenus();
        },

        editSubMenu(index) {
            this.editedIndex = this.editedIndex === index ? null : index;
        },

        onLinksChange(links, index) {
            this.subMenus[index].items = [...links];

            this.emitSubmenus();
        },

        emitSubmenus() {
            this.$emit('input', this.subMenus);
        }
    }
};
</script>
